<template>
  <div class="sp">
    <div class="sp-brew" :style="{ width: scrollProgress + '%' }"></div>

    <header class="sp-nav" :class="{ 'sp-scrolled': scrolled }">
      <a class="sp-lockup" @click="$router.push('/')">
        <img src="../assets/tcb-cup.png" alt="The Coffee Break cup logo" />
        <span>The Coffee Break</span>
      </a>
      <div class="sp-nav-actions">
        <div class="sp-menu-wrap" ref="menuWrap">
          <button
            class="sp-menu-btn"
            @click="menuOpen = !menuOpen"
            :aria-expanded="menuOpen"
          >
            Menu
          </button>
          <div class="sp-menu-dropdown" :class="{ 'sp-menu-open': menuOpen }">
            <a @click="goto('/')">Home</a>
            <a @click="goto('/career')">Career</a>
            <a @click="goto('/ilovetcb')">
              <svg class="sp-heart" viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true">
                <path
                  d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                ></path>
              </svg>
              Support Us
            </a>
            <a @click="onManageAccount">Manage Account</a>
          </div>
        </div>
        <button class="sp-cta" @click="focusFinalEmail">Subscribe — Free</button>
      </div>
    </header>

    <main>
      <section class="sp-hero ab-hero">
        <div class="sp-wrap sp-hero-wrap">
          <div class="sp-issue">Who we are</div>

          <h1 class="sp-display">
            <span class="sp-row"><span>About</span></span>
            <span class="sp-row"><span><em class="sp-cupword">Us.</em></span></span>
          </h1>

          <div class="sp-hero-foot">
            <div class="sp-hero-copy ab-hero-copy">
              <p class="sp-sub">
                We are The Coffee Break. We started this newsletter with a simple idea in
                mind: <b>making people more informed.</b>
              </p>
              <div class="ab-social">
                <a
                  class="ab-social-btn ab-fb"
                  href="https://www.facebook.com/breakmycoffee"
                  target="_blank"
                  rel="noopener"
                >
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
                    <path
                      d="M22 12.06C22 6.48 17.52 2 11.94 2S1.88 6.48 1.88 12.06c0 5.02 3.66 9.18 8.44 9.94v-7.03H7.9v-2.91h2.42V9.91c0-2.39 1.42-3.72 3.6-3.72 1.04 0 2.13.19 2.13.19v2.35h-1.2c-1.18 0-1.55.74-1.55 1.5v1.8h2.64l-.42 2.91h-2.22V22c4.78-.76 8.44-4.92 8.44-9.94Z"
                    ></path>
                  </svg>
                  The Coffee Break
                </a>
                <a
                  class="ab-social-btn ab-tw"
                  href="https://twitter.com/BreakMyCoffee"
                  target="_blank"
                  rel="noopener"
                >
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
                    <path
                      d="M23 4.98c-.88.39-1.83.65-2.82.77a4.93 4.93 0 0 0 2.16-2.72c-.95.56-2 .97-3.13 1.19a4.92 4.92 0 0 0-8.38 4.48A13.94 13.94 0 0 1 1.67 3.15a4.9 4.9 0 0 0 1.52 6.57 4.9 4.9 0 0 1-2.23-.62v.06a4.92 4.92 0 0 0 3.95 4.83 4.9 4.9 0 0 1-2.22.08 4.93 4.93 0 0 0 4.6 3.42A9.87 9.87 0 0 1 0 19.54a13.94 13.94 0 0 0 7.55 2.21c9.06 0 14.02-7.5 14.02-14.02 0-.21 0-.42-.02-.63A10 10 0 0 0 23 4.98Z"
                    ></path>
                  </svg>
                  @breakmycoffee
                </a>
              </div>
            </div>
          </div>

          <div class="sp-hero-art ab-hero-art" :style="{ transform: 'translateY(' + heroParallax + 'px)' }">
            <img src="../assets/phone.png" alt="The Coffee Break newsletter shown on a phone" />
          </div>
        </div>
      </section>

      <section class="ab-story">
        <div class="sp-wrap ab-story-wrap">
          <div class="sp-kicker" v-reveal>Our story</div>
          <h2 v-reveal>Why we started <em>writing</em>.</h2>
          <div class="ab-prose" v-reveal>
            <p>
              In the information age, it's easy to get overwhelmed by the array of news. The
              team reads a lot of news every day because of the nature of our work — in
              banking &amp; technology.
            </p>
            <p>
              With that, we figured there must be a better way for people to read the news
              other than skimming through multiple news portals.
            </p>
            <p>
              We started experimenting with our friends by sending the newsletter via Gmail
              during the early days. With their encouraging words, we decided to start the
              newsletter. As they say, the rest is history!
            </p>
            <p>
              Our 5-days-a-week newsletter aims to make people stay informed, with both local
              Malaysian and global news. If you want to be informed, subscribe to The Coffee
              Break.
            </p>
            <p>We hope to see you in your inbox!</p>
            <p class="ab-note">
              You won't have to worry about missing anything. Every new edition of the
              newsletter goes directly to your inbox. If they don't, it could be in your Spam
              folder or Promotions tab (Gmail users) — move them to your Primary inbox.
            </p>
          </div>
        </div>
      </section>

      <section class="sp-latest" v-if="latestLoading || latestIssues.length">
        <div class="sp-wrap">
          <div class="sp-kicker" v-reveal><span class="sp-live-dot"></span>Fresh off the press</div>
          <h2 v-reveal>Latest from<br /><em>the inbox.</em></h2>

          <div class="sp-latest-rows">
            <template v-if="latestLoading">
              <div class="sp-latest-row sp-latest-row--skeleton" v-for="n in 5" :key="n">
                <span class="sp-skel sp-skel--date"></span>
                <span class="sp-skel sp-skel--title"></span>
              </div>
            </template>
            <template v-else>
              <a
                class="sp-latest-row"
                v-reveal
                v-for="issue in latestIssues"
                :key="issue.guid"
                :href="issue.link"
                target="_blank"
                rel="noopener"
              >
                <span class="sp-latest-date">{{ issue.dateLabel }}</span>
                <span class="sp-latest-title">{{ issue.title }}</span>
                <span class="sp-latest-teaser">{{ issue.teaser }}</span>
                <span class="sp-latest-arrow">→</span>
              </a>
            </template>
          </div>
        </div>
      </section>

      <section class="ab-social-cta">
        <div class="sp-wrap ab-social-cta-wrap">
          <p v-reveal>
            Thank you for reading. If you don't like getting emails, follow us on our social
            media.
          </p>
          <div class="ab-social ab-social--center" v-reveal>
            <a
              class="ab-social-btn ab-fb"
              href="https://www.facebook.com/breakmycoffee"
              target="_blank"
              rel="noopener"
            >
              <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
                <path
                  d="M22 12.06C22 6.48 17.52 2 11.94 2S1.88 6.48 1.88 12.06c0 5.02 3.66 9.18 8.44 9.94v-7.03H7.9v-2.91h2.42V9.91c0-2.39 1.42-3.72 3.6-3.72 1.04 0 2.13.19 2.13.19v2.35h-1.2c-1.18 0-1.55.74-1.55 1.5v1.8h2.64l-.42 2.91h-2.22V22c4.78-.76 8.44-4.92 8.44-9.94Z"
                ></path>
              </svg>
              The Coffee Break
            </a>
            <a
              class="ab-social-btn ab-tw"
              href="https://twitter.com/BreakMyCoffee"
              target="_blank"
              rel="noopener"
            >
              <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
                <path
                  d="M23 4.98c-.88.39-1.83.65-2.82.77a4.93 4.93 0 0 0 2.16-2.72c-.95.56-2 .97-3.13 1.19a4.92 4.92 0 0 0-8.38 4.48A13.94 13.94 0 0 1 1.67 3.15a4.9 4.9 0 0 0 1.52 6.57 4.9 4.9 0 0 1-2.23-.62v.06a4.92 4.92 0 0 0 3.95 4.83 4.9 4.9 0 0 1-2.22.08 4.93 4.93 0 0 0 4.6 3.42A9.87 9.87 0 0 1 0 19.54a13.94 13.94 0 0 0 7.55 2.21c9.06 0 14.02-7.5 14.02-14.02 0-.21 0-.42-.02-.63A10 10 0 0 0 23 4.98Z"
                ></path>
              </svg>
              @breakmycoffee
            </a>
          </div>
        </div>
      </section>

      <section class="sp-final">
        <div class="sp-sun"></div>
        <div class="sp-wrap">
          <div class="sp-kicker sp-kicker--center" v-reveal>One email. Every weekday.</div>
          <h2 v-reveal>Wake up<br /><em>already caught up.</em></h2>
          <p v-reveal>Join &gt;24,000 Malaysians. Unsubscribe anytime — no hard feelings.</p>
          <form class="sp-capture sp-capture--center" v-reveal @submit.prevent="subscribeFinal">
            <input
              ref="finalEmail"
              v-model="finalEmail"
              type="email"
              required
              placeholder="you@email.com"
              aria-label="Email address"
            />
            <button class="sp-go" type="submit" :class="{ 'sp-go--ok': finalState === 'done' }">
              <template v-if="finalState === 'brewing'">Brewing… ☕</template>
              <template v-else-if="finalState === 'done'">You're in ✓</template>
              <template v-else>Subscribe <span class="sp-arr">→</span></template>
            </button>
          </form>
          <div class="sp-referral sp-referral--center sp-referral--after" v-reveal>
            <span class="sp-referral-label">Referral code</span>
            <input
              v-model="referral"
              class="sp-referral-input"
              placeholder="Referral code"
              aria-label="Referral code"
            />
          </div>
          <div class="sp-note" v-reveal>Free forever · No spam · 3-minute read</div>
        </div>
        <footer>
          <span>Copyright © 2023 FINLIT MEDIA TECH GROUP SDN BHD (1348643-U)</span>
          <span>Brewed in Kuala&nbsp;Lumpur ☕</span>
          <span>
            <a @click="$router.push('/about')">About</a> ·
            <a href="https://thecoffeebreak.substack.com/archive" target="_blank" rel="noopener">Archive</a> ·
            <a @click="$router.push('/ilovetcb')">Support us</a> ·
            <a @click="$router.push('/privacy-policy')">Privacy Policy</a> ·
            <a @click="$router.push('/terms-of-service')">Terms of Service</a>
          </span>
        </footer>
      </section>
    </main>
  </div>
</template>

<script>
import axios from "axios";

const SUBSCRIBE_URL =
  "https://hukopzhug3.execute-api.ap-southeast-1.amazonaws.com/production/email/submit";

export default {
  name: "AboutNew",
  directives: {
    reveal: {
      inserted(el) {
        el.classList.add("sp-reveal");
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
          el.classList.add("sp-in");
          return;
        }
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                el.classList.add("sp-in");
                io.unobserve(el);
              }
            });
          },
          { threshold: 0.15 }
        );
        io.observe(el);
      },
    },
  },
  data() {
    return {
      menuOpen: false,
      scrolled: false,
      scrollProgress: 0,
      heroParallax: 0,
      finalEmail: "",
      finalState: "idle",
      referral: "",
      latestIssues: [],
      latestLoading: true,
    };
  },
  mounted() {
    document.title = "About Us — The Coffee Break";
    const urlParams = new URLSearchParams(window.location.search);
    this.referral = urlParams.get("referral") || urlParams.get("ref") || "";
    window.addEventListener("scroll", this.onScroll, { passive: true });
    document.addEventListener("click", this.onDocClick);
    this.retrieveLatest();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
    document.removeEventListener("click", this.onDocClick);
  },
  methods: {
    onScroll() {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      this.scrollProgress = max > 0 ? (h.scrollTop / max) * 100 : 0;
      this.scrolled = h.scrollTop > 40;
      this.heroParallax = Math.min(h.scrollTop * 0.12, 90);
    },
    onDocClick(e) {
      if (this.menuOpen && this.$refs.menuWrap && !this.$refs.menuWrap.contains(e.target)) {
        this.menuOpen = false;
      }
    },
    goto(path) {
      this.menuOpen = false;
      this.$router.push(path);
    },
    onManageAccount() {
      this.menuOpen = false;
      window.open("https://billing.stripe.com/p/login/14k5mT1L4aFi6TC8ww", "_blank", "noreferrer");
    },
    focusFinalEmail() {
      this.$refs.finalEmail.scrollIntoView({ behavior: "smooth", block: "center" });
      this.$refs.finalEmail.focus();
    },
    async retrieveLatest() {
      try {
        const { data } = await axios.get(
          "https://hukopzhug3.execute-api.ap-southeast-1.amazonaws.com/production/retrieve-top-feeds"
        );
        this.latestIssues = (data.result || []).slice(0, 5).map((item) => {
          const teaser = (item.content || "").split(".")[0].trim();
          return {
            guid: item.guid,
            link: item.link,
            title: item.title.replace(/^☕️?\s*/, ""),
            teaser: teaser ? `${teaser}.` : "",
            dateLabel: new Intl.DateTimeFormat("en-MY", {
              day: "numeric",
              month: "short",
            }).format(new Date(item.date)),
          };
        });
      } catch {
        this.latestIssues = [];
      } finally {
        this.latestLoading = false;
      }
    },
    async subscribeFinal() {
      const emailVal = this.finalEmail.trim();
      if (!emailVal) return;
      this.finalState = "brewing";
      try {
        this.$gtag.event("subscribe", {
          event_label: "subscribe_about_new",
          value: emailVal,
        });
        await axios.post(SUBSCRIBE_URL, { email: emailVal, referral: this.referral.trim() });
        this.finalState = "done";
        this.finalEmail = "";
      } catch {
        this.finalState = "idle";
      }
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,400;12..96,600;12..96,800&family=Instrument+Serif:ital@0;1&family=Roboto+Mono:wght@400;500&display=swap");
</style>

<style scoped>
.sp {
  --paper: #faf7f0;
  --paper-2: #f3eee2;
  --ink: #101820;
  --ink-2: #3d4852;
  --ink-3: #7a8691;
  --blue: #007cb7;
  --blue-deep: #083d73;
  --sky: #e3f2fd;
  --volt: #ffdb00;
  --line: rgba(16, 24, 32, 0.14);
  --serif: "Instrument Serif", Georgia, serif;
  --grotesk: "Bricolage Grotesque", "Helvetica Neue", sans-serif;
  --mono: "Roboto Mono", Menlo, monospace;
  --ease: cubic-bezier(0.16, 1, 0.3, 1);

  font-family: var(--grotesk);
  background: var(--paper);
  color: var(--ink);
  -webkit-font-smoothing: antialiased;
  overflow-x: hidden;
  position: relative;
}
.sp *,
.sp *::before,
.sp *::after {
  box-sizing: border-box;
}
.sp ::selection {
  background: var(--volt);
  color: var(--ink);
}
.sp::after {
  content: "";
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 60;
  opacity: 0.05;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='140' height='140'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.85' numOctaves='2'/%3E%3C/filter%3E%3Crect width='140' height='140' filter='url(%23n)'/%3E%3C/svg%3E");
}

/* brew bar */
.sp-brew {
  position: fixed;
  top: 0;
  left: 0;
  height: 3px;
  background: var(--blue);
  z-index: 65;
}

/* nav */
.sp-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 32px;
  transition: background 0.3s, box-shadow 0.3s;
}
.sp-scrolled {
  background: rgba(250, 247, 240, 0.92);
  backdrop-filter: blur(12px);
  box-shadow: 0 1px 0 var(--line);
}
.sp-lockup {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: var(--ink);
  cursor: pointer;
}
.sp-lockup img {
  height: 30px;
  display: block;
}
.sp-lockup span {
  font-weight: 800;
  font-size: 16px;
  letter-spacing: -0.02em;
}
@keyframes sp-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}
.sp-nav-actions {
  display: flex;
  align-items: center;
  gap: 14px;
}
.sp-menu-wrap {
  position: relative;
}
.sp-menu-btn {
  font-family: var(--grotesk);
  font-weight: 800;
  font-size: 13px;
  letter-spacing: 0.02em;
  color: var(--ink);
  background: transparent;
  border: 1.5px solid var(--line);
  border-radius: 999px;
  padding: 10.5px 20px;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
}
.sp-menu-btn:hover {
  border-color: var(--blue);
  background: rgba(0, 124, 183, 0.06);
}
.sp-menu-dropdown {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  min-width: 200px;
  background: var(--paper);
  border: 1.5px solid var(--line);
  border-radius: 16px;
  padding: 10px;
  box-shadow: 0 20px 40px rgba(16, 24, 32, 0.14);
  display: none;
  flex-direction: column;
}
.sp-menu-dropdown.sp-menu-open {
  display: flex;
}
.sp-menu-dropdown a {
  font-family: var(--grotesk);
  font-size: 14px;
  font-weight: 600;
  color: var(--ink);
  text-decoration: none;
  padding: 10px 12px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.sp-menu-dropdown a:hover {
  background: var(--sky);
  color: var(--blue);
}
.sp-heart {
  color: #e5484d;
  vertical-align: -2px;
  margin-right: 4px;
}
/* desktop: list the links inline instead of behind the Menu button */
@media (min-width: 961px) {
  .sp-menu-btn {
    display: none;
  }
  .sp-menu-dropdown {
    position: static;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2px;
    min-width: 0;
    padding: 0;
    background: transparent;
    border: none;
    box-shadow: none;
  }
  .sp-menu-dropdown a {
    white-space: nowrap;
  }
}
.sp-cta {
  font-family: var(--grotesk);
  font-weight: 800;
  font-size: 13px;
  letter-spacing: 0.02em;
  color: var(--paper);
  background: var(--ink);
  border: none;
  border-radius: 999px;
  padding: 12px 22px;
  cursor: pointer;
  transition: transform 0.3s var(--ease), background 0.3s;
}
.sp-cta:hover {
  background: var(--blue);
  transform: scale(1.05);
}
@media (max-width: 720px) {
  .sp-nav-actions {
    gap: 8px;
  }
  .sp-menu-btn {
    padding: 9px 14px;
    font-size: 12px;
  }
  .sp-cta {
    padding: 10px 16px;
    font-size: 12px;
  }
  .sp-nav {
    padding: 14px 18px;
  }
}
@media (max-width: 420px) {
  .sp-lockup span {
    display: none;
  }
}

/* hero */
.sp-hero {
  min-height: 100svh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 120px 32px 0;
  position: relative;
}
.ab-hero {
  min-height: 90svh;
  padding-bottom: 80px;
}
.sp-hero-wrap {
  width: 100%;
  max-width: 1400px;
  position: relative;
  margin: 0 auto;
}
.sp-issue {
  font-family: var(--mono);
  font-size: 12px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--ink-3);
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 28px;
}
.sp-issue::before {
  content: "";
  width: 44px;
  height: 1px;
  background: var(--ink);
  display: inline-block;
}
.sp-display {
  font-weight: 800;
  font-size: clamp(58px, 11.6vw, 178px);
  line-height: 0.92;
  letter-spacing: -0.04em;
  margin: 0;
  text-transform: uppercase;
}
.sp-row {
  display: block;
  overflow: hidden;
}
.sp-row > span {
  display: inline-block;
  transform: translateY(110%);
  animation: sp-rise 1.1s var(--ease) forwards;
}
.sp-row:nth-child(2) > span {
  animation-delay: 0.12s;
}
@keyframes sp-rise {
  to {
    transform: translateY(0);
  }
}
.sp-display em {
  font-family: var(--serif);
  font-style: italic;
  font-weight: 400;
  text-transform: none;
  letter-spacing: -0.01em;
  color: var(--blue);
}
.sp-cupword {
  position: relative;
  white-space: nowrap;
}
.sp-cupword::after {
  content: "";
  position: absolute;
  left: -2%;
  right: -2%;
  bottom: 6%;
  height: 0.18em;
  background: var(--volt);
  z-index: -1;
  transform: scaleX(0);
  transform-origin: left;
  animation: sp-swipe 0.8s var(--ease) 1s forwards;
}
@keyframes sp-swipe {
  to {
    transform: scaleX(1);
  }
}
.sp-hero-foot {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 40px;
  margin-top: 56px;
  flex-wrap: wrap;
}
.sp-hero-copy {
  max-width: 400px;
}
.sp-sub {
  font-size: 17px;
  line-height: 1.55;
  color: var(--ink-2);
  margin: 0;
}
.sp-sub b {
  color: var(--ink);
}
.sp-referral {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 16px;
}
.sp-referral--center {
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 8px;
  max-width: 520px;
}
.sp-referral--after {
  margin-top: 20px;
  margin-bottom: 0;
  opacity: 0.75;
}
.sp-referral-label {
  font-family: var(--mono);
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--ink-3);
  white-space: nowrap;
}
.sp-referral-input {
  height: 36px;
  padding: 0 16px;
  font-family: var(--grotesk);
  font-size: 13px;
  color: var(--ink);
  background: transparent;
  border: 1.5px solid var(--line);
  border-radius: 999px;
  outline: none;
  flex: 1;
  transition: border-color 0.2s;
}
.sp-referral-input::placeholder {
  color: var(--ink-3);
}
.sp-referral-input:focus {
  border-color: var(--blue);
}
.sp-capture {
  display: flex;
  gap: 10px;
  flex: 1;
  max-width: 520px;
  min-width: 300px;
}
.sp-capture--center {
  margin: 0 auto;
  justify-content: center;
}
.sp-capture input {
  flex: 1;
  line-height: 1;
  padding: 9px 16px;
  font-family: var(--grotesk);
  font-size: 13px;
  color: var(--ink);
  background: transparent;
  border: 1.5px solid var(--line);
  border-radius: 999px;
  outline: none;
  transition: border-color 0.2s, background 0.2s;
}
.sp-capture input::placeholder {
  color: var(--ink-3);
}
.sp-capture input:focus {
  border-color: var(--blue);
  background: #fff;
}
.sp-go {
  height: 36px;
  padding: 0 20px;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  background: var(--blue);
  color: #fff;
  font-family: var(--grotesk);
  font-weight: 800;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  transition: background 0.25s;
  position: relative;
}
.sp-go:hover {
  background: var(--blue-deep);
}
.sp-go--ok {
  background: #27ae60;
}
.sp-arr {
  transition: transform 0.3s var(--ease);
  display: inline-block;
}
.sp-go:hover .sp-arr {
  transform: translateX(5px);
}
@media (max-width: 520px) {
  .sp-capture {
    flex-direction: column;
    min-width: 0;
    width: 100%;
  }
  .sp-capture input,
  .sp-go {
    width: 100%;
  }
  .sp-go {
    justify-content: center;
  }
}

/* about social buttons */
.ab-social {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 20px;
}
.ab-social--center {
  justify-content: center;
  margin-top: 24px;
}
.ab-social-btn {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 11px 18px;
  border-radius: 999px;
  font-family: var(--grotesk);
  font-weight: 700;
  font-size: 13px;
  text-decoration: none;
  color: #fff;
  transition: transform 0.2s var(--ease), opacity 0.2s;
}
.ab-social-btn:hover {
  opacity: 0.92;
  transform: scale(1.03);
}
.ab-fb {
  background: #1877f2;
}
.ab-tw {
  background: #1da1f2;
}

/* about hero art (phone mockup) */
.sp-hero-art {
  position: absolute;
  right: 3vw;
  bottom: 0;
  pointer-events: none;
  z-index: 2;
}
.ab-hero-art {
  width: clamp(160px, 15vw, 240px);
}
.ab-hero-art img {
  width: 100%;
  display: block;
  filter: drop-shadow(0 30px 50px rgba(16, 24, 32, 0.18));
}
@media (max-width: 1100px) {
  .ab-hero-art {
    opacity: 1;
  }
}
@media (max-width: 720px) {
  .sp-hero {
    padding: 110px 18px 0;
  }
  .ab-hero-art {
    display: none;
  }
  .sp-hero-foot {
    margin-top: 40px;
  }
}

/* shared */
.sp-wrap {
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 32px;
}
@media (max-width: 720px) {
  .sp-wrap {
    padding: 0 18px;
  }
}
.sp-kicker {
  font-family: var(--mono);
  font-size: 12px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--ink-3);
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
}
.sp-kicker::before {
  content: "";
  width: 44px;
  height: 1px;
  background: currentColor;
}
.sp-kicker--center {
  justify-content: center;
}

.sp-reveal {
  opacity: 0;
  transform: translateY(36px);
  transition: opacity 0.9s var(--ease), transform 0.9s var(--ease);
}
.sp-reveal.sp-in {
  opacity: 1;
  transform: none;
}

/* story */
.ab-story {
  padding: 130px 0 90px;
}
.ab-story-wrap {
  max-width: 900px;
}
.ab-story h2 {
  font-weight: 800;
  font-size: clamp(32px, 4.6vw, 56px);
  letter-spacing: -0.03em;
  line-height: 1.02;
  margin: 0 0 44px;
}
.ab-story h2 em {
  font-family: var(--serif);
  font-style: italic;
  font-weight: 400;
  color: var(--blue);
}
.ab-prose p {
  font-size: 18px;
  line-height: 1.7;
  color: var(--ink-2);
  margin: 0 0 24px;
  max-width: 720px;
}
.ab-prose p:first-child {
  color: var(--ink);
  font-weight: 600;
}
.ab-note {
  font-size: 15px !important;
  color: var(--ink-3) !important;
  font-weight: 400 !important;
  padding-top: 8px;
  border-top: 1px solid var(--line);
}
@media (max-width: 720px) {
  .ab-story {
    padding: 64px 0 48px;
  }
  .ab-prose p {
    font-size: 16px;
  }
}

/* latest issues */
.sp-latest {
  padding: 90px 0 70px;
}
.sp-live-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #27ae60;
  animation: sp-pulse 2s infinite;
  display: inline-block;
}
.sp-latest h2 {
  font-weight: 800;
  font-size: clamp(32px, 4.6vw, 56px);
  letter-spacing: -0.03em;
  line-height: 1.02;
  margin: 0 0 48px;
}
.sp-latest h2 em {
  font-family: var(--serif);
  font-style: italic;
  font-weight: 400;
  color: var(--blue);
}
.sp-latest-rows {
  border-top: 1.5px solid var(--ink);
}
.sp-latest-row {
  display: grid;
  grid-template-columns: 90px 1fr auto;
  align-items: baseline;
  gap: 24px;
  padding: 26px 8px;
  border-bottom: 1px solid var(--line);
  text-decoration: none;
  color: inherit;
}
.sp-latest-date {
  font-family: var(--mono);
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--ink-3);
}
.sp-latest-title {
  font-weight: 800;
  font-size: 18px;
  letter-spacing: -0.01em;
  transition: color 0.2s;
}
.sp-latest-row:hover .sp-latest-title {
  color: var(--blue);
}
.sp-latest-teaser {
  font-size: 14px;
  color: var(--ink-2);
  grid-column: 2;
  margin-top: -10px;
}
.sp-latest-arrow {
  grid-row: 1 / 3;
  grid-column: 3;
  align-self: center;
  font-size: 18px;
  transition: transform 0.3s var(--ease);
}
.sp-latest-row:hover .sp-latest-arrow {
  transform: translateX(5px);
  color: var(--blue);
}
.sp-skel {
  display: block;
  border-radius: 4px;
  background: linear-gradient(90deg, var(--line) 25%, rgba(16, 24, 32, 0.06) 37%, var(--line) 63%);
  background-size: 400% 100%;
  animation: sp-shimmer 1.4s ease infinite;
}
.sp-skel--date {
  width: 50px;
  height: 12px;
}
.sp-skel--title {
  width: min(60%, 380px);
  height: 18px;
}
@keyframes sp-shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
@media (max-width: 720px) {
  .sp-latest {
    padding: 56px 0 40px;
  }
  .sp-latest-row {
    grid-template-columns: 56px 1fr auto;
    gap: 14px;
    padding: 20px 0;
  }
  .sp-latest-teaser {
    display: none;
  }
  .sp-latest-title {
    font-size: 16px;
  }
}

/* social CTA band */
.ab-social-cta {
  padding: 90px 0;
  background: var(--paper-2);
  text-align: center;
}
.ab-social-cta-wrap {
  max-width: 560px;
}
.ab-social-cta p {
  font-size: 17px;
  color: var(--ink-2);
  margin: 0;
}
@media (max-width: 720px) {
  .ab-social-cta {
    padding: 56px 0;
  }
}

/* final CTA */
.sp-final {
  padding: 150px 0 60px;
  text-align: center;
  position: relative;
  overflow: hidden;
}
.sp-sun {
  position: absolute;
  left: 50%;
  bottom: -32vw;
  transform: translateX(-50%);
  width: 64vw;
  height: 64vw;
  border-radius: 50%;
  background: radial-gradient(circle at 50% 30%, var(--sky) 0%, rgba(227, 242, 253, 0) 70%);
  pointer-events: none;
}
.sp-final h2 {
  font-weight: 800;
  font-size: clamp(44px, 8vw, 120px);
  line-height: 0.95;
  letter-spacing: -0.04em;
  text-transform: uppercase;
  margin: 0 0 18px;
  position: relative;
}
.sp-final h2 em {
  font-family: var(--serif);
  font-style: italic;
  font-weight: 400;
  text-transform: none;
  color: var(--blue);
}
.sp-final p {
  font-size: 17px;
  color: var(--ink-2);
  margin: 0 0 44px;
  position: relative;
}
.sp-final .sp-capture {
  margin: 0 auto;
  position: relative;
}
.sp-note {
  margin-top: 18px;
  font-family: var(--mono);
  font-size: 11.5px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--ink-3);
  position: relative;
}

@media (max-width: 720px) {
  .sp-final {
    padding: 90px 0 40px;
  }
  footer {
    margin-top: 64px;
  }
}

footer {
  margin-top: 130px;
  border-top: 1.5px solid var(--ink);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 26px 32px;
  font-family: var(--mono);
  font-size: 11.5px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--ink-3);
  flex-wrap: wrap;
  position: relative;
  background: var(--paper);
}
footer a {
  color: var(--ink);
  text-decoration: none;
  cursor: pointer;
}
footer a:hover {
  color: var(--blue);
}

@media (prefers-reduced-motion: reduce) {
  .sp-row > span {
    animation: none;
    transform: none;
  }
  .sp-cupword::after {
    animation: none;
    transform: scaleX(1);
  }
  .sp-reveal {
    opacity: 1;
    transform: none;
    transition: none;
  }
}
</style>
